import { IIntroductionLinkProps } from '../components/home-components/instruction-link';

export const homePageInstructionsWeb1 = [
  {
    name: 'CREATE PRIVATE (JOURNAL) NOTES',
    pdfUrl: '/documents/web/Create Private Journal Note (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
  {
    name: 'CREATE CLOSED GROUP NOTES',
    pdfUrl: '/documents/web/Create Closed Group Notes (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
  {
    name: 'CREATE PUBLIC GROUP NOTES',
    pdfUrl: '/documents/web/Create Public Group Notes (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
  {
    name: 'CREATE HIGHLIGHTS, ADDING IMAGE/TEXT',
    pdfUrl: '/documents/web/Create Highlights (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
  {
    name: 'CREATE CLOSED OR PUBLIC GROUPS',
    pdfUrl: '/documents/web/Create Closed or Public Groups (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
];
